










































































































































































































































































import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";
import store from "@/store";
import moment from "moment";
import _ from "underscore";
import diagnosticTypesHelper from "Utilities/diagnostic-types-helper";
//  @types
import { ITrendBenefit } from "@/types/trendBenefit";
import { ILongTrend } from "@/types/longTrend";
import { VesselEvent } from "@/types/vesselEvent";
//  @modules
import { getModule } from "vuex-module-decorators";
import SnackbarModule from "@/store/clients/Snackbar.module";
import VesselsModule from "@/store/clients/Vessels.module";
import VesselEventsModule from "@/store/clients/VesselEvents.module";
import BenefitsModule from "@/store/clients/Benefits.module";

const TrendEventBenefits = getModule(BenefitsModule, store);
const Snackbar = getModule(SnackbarModule, store);
const VesselEvents = getModule(VesselEventsModule, store);
const Vessels = getModule(VesselsModule, store);

@Component({})
export default class TrendEventImpactModal extends Vue {
  @PropSync("value", { required: true, type: Boolean, default: false }) isModalActive!: boolean;
  @Prop({ type: String, default: "460px" }) width!: string;
  @Prop() readonly longTrend!: ILongTrend;
  @Prop({ type: Boolean, default: true }) readonly hasNoTrendEvents!: boolean;
  @Prop() draftValue!: number;

  // @Data
  benefitData: ITrendBenefit = {} as ITrendBenefit;
  isBenefitLoading = true;
  selectedTrendEvent: any = {};
  loadBenefitError: string | boolean = false;
  draft: number = this.draftValue;
  doDraftUpdateDebounced = _.debounce((value: number) => this.updateDraft(value), 2000);

  onDraftInput() {
    this.$nextTick(() => {
      const input = this.$refs.draftInput as any;
      if (input && typeof input.validate === "function" && input.validate() === true) {
        this.doDraftUpdateDebounced(this.draft);
      }
    });
  }

  async updateDraft(newValue: number): Promise<void> {
    this.draft = Number(newValue);
    const data = {
      vesselId: this.longTrend.vesselId,
      draft: this.draft,
    };
    try {
      await Vessels.updateVesselDraft(data);
      this.fetchBenefitData();
      Snackbar.showSnackbar({
        text: `Draft successfully updated to <b>${this.draft} m</b>`,
        color: "ContentPrimaryStatic",
      });
    } catch (error) {
      Snackbar.showSnackbar({ text: "Failed to update draft" });
    }
  }

  @Watch("trendEvents")
  trendEventsChanged(): void {
    this.selectedTrendEvent = this.trendEvents[0];
  }

  @Watch("longTrend")
  longtrendchanged(): void {
    this.fetchBenefitData();
  }

  //  @Getters
  get performanceMetricDiff(): { value: string; isPositive: boolean; isNegative: boolean; icon: string; color: string; class: string; show: boolean; sign: string } | null {
    const prev = Number(this.benefitData?.prevEndValue ?? 0);
    const next = Number(this.benefitData?.nextBenchmarkValue ?? 0);
    if (isNaN(prev) || isNaN(next)) {
      return null;
    }
    const diff = next - prev;
    return {
      value: Math.abs(diff).toFixed(2),
      isPositive: diff > 0,
      isNegative: diff < 0,
      icon: diff > 0 ? "$ArrowUp" : "$ArrowDown",
      color: diff > 0 ? "ContentPositivePrimary" : "ContentNegativePrimary",
      class: diff > 0 ? "up" : "down",
      show: diff !== 0,
      sign: diff > 0 ? "" : "-",
    };
  }

  isSpeedChangeNegative(value: string): boolean {
    return Number(value.split(" knots")[0]) < 0;
  }

  isFuelOilImpactNegative(value: string): boolean {
    return Number(value.split(" MT/day")[0]) < 0;
  }
  async created(): Promise<void> {
    this.selectedTrendEvent = this.trendEvents[0];
    await this.fetchBenefitData();
  }

  async fetchBenefitData(): Promise<void> {
    try {
      this.isBenefitLoading = true;
      this.benefitData = await TrendEventBenefits.fetchBenefit({ trendEventId: this.selectedTrendEvent.id, longTrendId: this.longTrend.id });
      this.draft = Number(this.benefitData.draft.toFixed(1));
      this.loadBenefitError = false;
    } catch (error) {
      this.loadBenefitError = error as string;
    } finally {
      this.isBenefitLoading = false;
    }
  }

  get trendEvents(): VesselEvent[] {
    return VesselEvents.trendEvents;
  }

  get benefitText(): string {
    return diagnosticTypesHelper.getBenefitText(this.longTrend.diagnosticType);
  }

  get hasConsequenceResults(): boolean {
    return this.benefitData?.consequences?.length ? this.benefitData.consequences[0].results.length > 0 : false;
  }

  get headers(): any[] {
    const headers: any[] = [];

    if (!this.benefitData?.consequences[0].results.length) return headers;

    headers.push({ text: "MCR", value: "MCR" });

    this.benefitData?.consequences[0].results.forEach(result => {
      headers.push({ text: result.headerName, value: result.headerName.split(/\W+/).join("") });
    });

    return headers;
  }

  get rows(): any[] {
    const rows: any[] = [];

    this.benefitData?.consequences.forEach(consequence => {
      const item: any = { MCR: consequence.mcrDisplay };

      consequence.results.forEach(result => {
        item[result.headerName.split(/\W+/).join("")] = result.displayValue;
      });
      rows.push(item);
    });

    return rows;
  }

  get errorText(): string {
    switch (this.loadBenefitError) {
      case "Benchmarking":
        return "*Impact could not be calculated. This may be due to the trend period before or after the selected event being used for benchmarking or lacking data";
      default:
        return "*Impact could not be calculated. This may be due to the trend period before or after the selected event being used for benchmarking or lacking data.";
    }
  }

  formatDateForDisplay(date: any): string {
    return moment(date).format("D MMM YYYY");
  } //use parent?

  close(): void {
    this.isModalActive = false;
  }

  draftInputRules(value: number): boolean | string {
    if (value === null || value === undefined) {
      return "Draft is required";
    }
    if (typeof value !== "number" || !Number.isFinite(value)) {
      return "Draft must be a number";
    }
    if (value < 2 || value > 25) {
      return "Draft should be between 2 and 25";
    }
    return true;
  }
}
